import React from 'react'
import { useNavigate, useLocation } from "react-router-dom";
import CommonNavbar from '../../Navbar/CommonNavbar';

const DashboardHeader = ({ onSearch, disableSearch = false }) => {
    const navigate = useNavigate();
    const location = useLocation(); 

    const handleNavigation = (path) => {
        navigate(path); 
    };
    return (
        <div>
            <header>
                <nav className="nav-items">
                    <p>Dashboard</p>
                   <CommonNavbar onSearch={onSearch} disableSearch={disableSearch} />

                </nav>
            </header>
        </div>
    )
}

export default DashboardHeader
